<template>
  <div>
    <van-dropdown-menu active-color="#FFD100">
      <van-dropdown-item v-model="value" :options="option"  @change="switchQuery"/>
      <van-dropdown-item :title="titlevalue" v-model="titlevalue" @closed="changeDevelop" ref="item" :disabled='disabled'>
        <van-datetime-picker
          v-model="currentDate"
          :type="type"
          title="选择查询日期"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="confirmPicker"
          @cancel="canceldatetime"
        />

      </van-dropdown-item>
    </van-dropdown-menu>

    <div class="income">
      <div class="textcenter cfff font40 datetime">金额（元）</div>
      <div class="textcenter cfff incomeall">{{data.totalAmount}}</div>

    </div>
    <div class="incomedatainfo c666">
      <div class="incomedatainfo-li">
        <div class="font30">{{data.ordersNumbers}}</div>
        <div class="font32 mt10">订单数</div>
      </div>
      <div class="incomedatainfo-li">
         <div class="font30">{{data.goodScores}}</div>
        <div class="font32 mt10">好评数</div>
      </div>
      <div class="incomedatainfo-li">
         <div class="font30">{{data.badScores}}</div>
        <div class="font32 mt10">差评数</div>
      </div>
    </div>
  </div>
</template>

<script>

export default{
  name: 'analysis', // 服务页面
  data () {
    return {
      type: 'date', // 选择的日期格式（年月或者年月日）
      minDate: new Date(2020, 0, 1), // 选择时间最小日期
      maxDate: new Date(), // 选择时间最大日期
      currentDate: new Date(), // 当前日期
      timeValue: '', // 确定选择的时间
      titlevalue: '', // 头部文字
      value: 1, // 要查绚的方式（ 2月 1日 0总）
      option: [
        { text: '日收入', value: 1 },
        { text: '月收入', value: 2 },
        { text: '总收入', value: 0 }
      ],
      disabled: false,
      data: {
        totalAmount: '0', // 总金额
        ordersNumbers: '0', // 订单数
        goodScores: '0', // 好评
        badScores: '0'// 差评
      }
    }
  },
  created () {

  },
  mounted () {
    this.confirmPicker(new Date())
  },

  methods: {
    // 修改选择时间头部显示
    changeDevelop () {
      this.titlevalue = this.timeValue
    },
    formatter (type, val) {
      if (type === 'year') {
        return val + '年'
      }
      if (type === 'month') {
        return val + '月'
      }
      if (type === 'day') {
        return val + '日'
      }
      return val
    },
    // 确认选择的时间
    confirmPicker (val) {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      if (this.value == 1) {
        this.timeValue = `${year}-${month}-${day}`
      } else {
        this.timeValue = `${year}-${month}`
      }
      this.changeDevelop()
      this.incomeAnalysisInfo(this.timeValue, this.value.toString())
      this.$refs.item.toggle(false)
    },
    // 取消时间选择
    canceldatetime () {
      this.$refs.item.toggle()
    },
    switchQuery () {
      switch (this.value) {
        case 1:
          this.type = 'date'// 将选择时间改为年月日
          this.disabled = false// 可以选择查询日期
          this.changeDevelop()// 选择完毕以后将选择的头部文字改掉（视图）
          this.confirmPicker(new Date())
          // this.incomeAnalysisInfo(date, this.value.toString())// 请求数据
          break
        case 2:
          this.type = 'year-month'
          this.disabled = false
          this.changeDevelop()
          this.confirmPicker(new Date())
          // date = date.slice(0, -3)// 截取日期只保留月
          // this.incomeAnalysisInfo(date, this.value.toString())// 请求数据
          break
        case 0:
          this.timeValue = '总收入'
          this.disabled = true
          this.changeDevelop()
          var date = ''// 全部查询（日期为空）
          this.incomeAnalysisInfo(date, this.value.toString())// 请求数据
          break
      }
    },
    // 获取收入分析数据
    incomeAnalysisInfo (date, type) {
      console.log(date, type)
      var that = this
      this.$api.HZrequest('/we-chat/gzh/washer/order/analysis', 'POST', {'date': date, 'type': type}).then((res) => {
        if (res.code == 200) {
          that.data = res.data
        }
      })
    }

  }

}
</script>

<style>
.income{width: 100%;height: 4rem;background: #FFD100;padding-top: 0.6rem;box-sizing: border-box;}
.incomeall{font-size: 0.8rem !important;}
.incomedatainfo{width: 6.9rem;height: 2.1rem;background: #fff;box-shadow:0px 0px 29px 0px rgba(200,200,200,0.17);border-radius:0.16rem;margin: 0 auto;margin-top: -1rem;display: flex;align-items: center;}
.incomedatainfo-li{width: 33.33%;box-sizing: border-box;height: 70%;border-right: 1px solid #eee;flex-wrap: wrap;text-align: center;padding-top: 0.3rem;}
.incomedatainfo-li:last-child{border-right: 0;}
.incnum{line-height: 0.3rem;}
</style>



// WEBPACK FOOTER //
// src/view/analysis.vue